<div class="card mx-auto" style="border-radius: 20px; width: 66%;">
    <div class="card-body">
        <div class="row">
            <div class="col-12">
                <!-- <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                    <div class="mb-2 mb-sm-0 ">
                        <input [ngModel]="true" [value]="true"
                            class="form-check-input"  type="radio" name="flexRadioDefault"
                            [id]="'flexRadioDefault' + assessment?.title">
                        <label class="form-check-label ms-2" style="text-decoration: underline;" [for]="'flexRadioDefault' + assessment?.title">
                            <span style="font-size: 16px; font-weight: 600;">{{ assessment?.title }} ({{ assessment?.titleAbbr }})</span>
                        </label>
                    </div> -->
                    <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                        <div class="mb-2 mb-sm-0">
                            <input style="cursor: pointer;" [ngModel]="true" [value]="true" class="form-check-input" type="radio" name="flexRadioDefault" [id]="'flexRadioDefault' + assessment?.title">
                            <label class="form-check-label ms-2" for="flexRadioDefault1">
                                <span style="cursor: pointer; text-decoration: underline;" class="h6">{{assessment?.titleAbbr}}</span>
                        </label>
                    </div>
                    <div>
                        <!-- <span style="color: #A3A3A3;"
                            class="text-decoration-line-through h5">₹{{data?.cancelAmount}}</span>
                        <span [ngClass]="data?.title === 'Advanced Report' ? 'text-success' : ''"
                            class="h4 ms-2">₹{{data?.sellingAmount}}<span class="text-danger">*</span>
                        </span> -->
                        <span style="color: #A3A3A3;"
                            class="text-decoration-line-through h5">₹{{ assessment?.maxAssessmentPrice }}</span>
                        <span class="h4 ms-2 text-success">₹{{ assessment?.assessmentPrice }}<span class="text-danger">*</span>
                        </span>
                        <div class="small mt-2" style="color: #A3A3A3;">*Taxes as Applicable</div>
                    </div>
                </div>
                <hr class="mt-2 mb-2">
            </div>
            <div class="col-12">
                <!-- <div [innerHTML]="formatDescription(data.description)"></div> -->
                 <div style="font-size: 14px;">The Course Certificate/Report will be bundled with the course purchase itself and will be <strong>available for download upon completion</strong> of the same.</div>
            </div>
        </div>
    </div>
</div>